import { render } from "./PersonalBody.vue?vue&type=template&id=29fec776&scoped=true"
import script from "./PersonalBody.vue?vue&type=script&lang=js"
export * from "./PersonalBody.vue?vue&type=script&lang=js"

import "./../../assets/styles/scripts/main.scss?vue&type=style&index=0&id=29fec776&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29fec776"]])

export default __exports__